import { render, staticRenderFns } from "./SilentRenewOIDC.vue?vue&type=template&id=6140aea9"
import script from "./SilentRenewOIDC.vue?vue&type=script&lang=ts"
export * from "./SilentRenewOIDC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6140aea9')) {
      api.createRecord('6140aea9', component.options)
    } else {
      api.reload('6140aea9', component.options)
    }
    module.hot.accept("./SilentRenewOIDC.vue?vue&type=template&id=6140aea9", function () {
      api.rerender('6140aea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/authentication/OIDC/SilentRenewOIDC.vue"
export default component.exports